import { render, staticRenderFns } from "./TabInfoPanel.vue?vue&type=template&id=4befa2ad&scoped=true"
import script from "./TabInfoPanel.vue?vue&type=script&lang=js"
export * from "./TabInfoPanel.vue?vue&type=script&lang=js"
import style0 from "./TabInfoPanel.vue?vue&type=style&index=0&id=4befa2ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4befa2ad",
  null
  
)

export default component.exports